import { createContext } from 'react';

const usePlanDetailsContext = createContext();
export default usePlanDetailsContext;
